<template>
  <div>
    <v-snackbar top :color="color" :timeout="delay" v-model="show" min-width="auto">
      <div style="width: 100%;text-align: center">{{message}}</div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      color: 'info',
      show: false,
      delay: 3000
    }
  },
  methods: {
    showInfo (message) {
      this.message = message
      this.color = 'info'
      this.show = true
      if (message && message.length > 25) this.delay = 6000
    },
    showSuccess (message) {
      this.message = message
      this.color = 'success'
      this.show = true
      if (message && message.length > 25) this.delay = 6000
    },
    showError (message) {
      this.message = message
      this.color = 'error'
      this.show = true
      if (message && message.length > 25) this.delay = 6000
    },
    showWarning (message) {
      this.message = message
      this.color = 'warning'
      this.show = true
      if (message && message.length > 25) this.delay = 6000
    }
  }
}
</script>
<style>
.v-application--is-ltr .v-snack__action {
    margin-right: 0px;
}
</style>
